module.exports = __webpack_public_path__ + "img/journal-bookmark-fill.7da4b4ec.svg";